import { useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Stack, Typography, Box, Button, Card, CardContent } from '@mui/material';
// components
import Iconify from '../../components/Iconify';
import {
  Before3WayCheckListDialog,
  Before3WayPrepListDialog,
} from './';

// ----------------------------------------------------------------------

const GreenCard = styled(Card)(({ theme }) => {
  return {
    width: '100%',
    border: `1px solid ${theme.palette.oldprimary.main}`,
  };
});

const GreenText = styled('span')(({ theme }) => {
  return {
    color: theme.palette.oldprimary.main,
  };
});

const BlueCard = styled(Card)(({ theme }) => {
  return {
    width: '100%',
    border: `1px solid ${theme.palette.info.main}`,
  };
});

const BlueText = styled('span')(({ theme }) => {
  return {
    color: theme.palette.info.main,
  };
});


export default function PrepGuide3Way({ checkList, prepList }) {
  const [isOpenCheckList, setIsOpenCheckList] = useState(false);
  const [isOpenPrepList, setIsOpenPrepList] = useState(false);

  return (
    <>
    <Stack direction={{ xs: "column", sm: "row" }} spacing={3} sx={{ mb: 3 }}>
      <GreenCard>
        <CardContent>
          <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 0.5 }}>
            <Iconify icon={'eva:checkmark-square-2-fill'} sx={{ color: "oldprimary.main" }} width={18} height={18} />
            <Typography variant="subtitle2" sx={{ color: "oldprimary.main" }}>
              꼭 확인해주세요!
            </Typography>
          </Stack>
          <Typography variant="h6" gutterBottom>
            사전 미팅때 내가 꼭 <GreenText>체크</GreenText>해야할 사항
          </Typography>
          <Box sx={{ justifyContent: "flex-end", display: "flex" }}>
            <Button
              disableRipple
              sx={{ color: "oldprimary" }}
              color="oldprimary"
              endIcon={<Iconify icon={'ic:baseline-arrow-right-alt'} />}
              onClick={() => setIsOpenCheckList(true)}>
              확인하기
            </Button>
          </Box>
        </CardContent>
      </GreenCard>
      <BlueCard>
        <CardContent>
          <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 0.5 }}>
            <Iconify icon={'eva:info-fill'} sx={{ color: "info.main" }} width={18} height={18} />
            <Typography variant="subtitle2" sx={{ color: "info.main" }}>
              꼭 준비해주세요!
            </Typography>
          </Stack>
          <Typography variant="h6" gutterBottom>
            사전 미팅때 내가 꼭 <BlueText>준비</BlueText>해야할 사항
          </Typography>
          <Box sx={{ justifyContent: "flex-end", display: "flex" }}>
            <Button
              disableRipple
              sx={{ color: "info" }}
              color="info"
              endIcon={<Iconify icon={'ic:baseline-arrow-right-alt'} />}
              onClick={() => setIsOpenPrepList(true)}>
              확인하기
            </Button>
          </Box>
        </CardContent>
      </BlueCard>
    </Stack>
    {/* dialogs */}
    <Before3WayCheckListDialog isOpen={isOpenCheckList} closeDialog={() => setIsOpenCheckList(false)} checkList={checkList} />
    <Before3WayPrepListDialog isOpen={isOpenPrepList} closeDialog={() => setIsOpenPrepList(false)} prepList={prepList} />
    </>
  )
}